import Edit from './Edit';
import List from './List';
import ListInactive from './ListInactive';
import Rapor from './Rapor';
import View from './View';
export { View, Edit, List, Rapor, ListInactive };



//////////////////
// WEBPACK FOOTER
// ./src/app/common/company/index.ts
// module id = 1262
// module chunks = 0